import React from 'react';

const TYPE_META = {
  t2i: { label: 'T2I', color: 'var(--accent)',  icon: '🖼' },
  i2i: { label: 'I2I', color: 'var(--accent4)', icon: '✏️' },
  t2v: { label: 'T2V', color: 'var(--accent3)', icon: '🎥' },
  i2v: { label: 'I2V', color: 'var(--accent2)', icon: '🎬' },
  r2v: { label: 'R2V', color: 'var(--accent5)', icon: '🎭' },
};

function formatTime(date) {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
}

function HistoryItem({ item }) {
  const meta = TYPE_META[item.type] || { label: item.type, icon: '◈', color: 'var(--text2)' };
  const isVideo = item.type.endsWith('v');

  const download = (e) => {
    e.stopPropagation();
    const a = document.createElement('a');
    a.href = item.url;
    a.download = `grok-${item.type}-${item.id}.${isVideo ? 'mp4' : 'png'}`;
    a.click();
  };

  return (
    <div className="history-item">
      {isVideo ? (
        <video src={item.url} className="history-thumb-video" muted />
      ) : item.url ? (
        <img src={item.url} alt="" className="history-thumb" />
      ) : (
        <div className="history-thumb-placeholder">{meta.icon}</div>
      )}
      <div className="history-meta">
        <span className="history-meta-type" style={{ color: meta.color }}>
          {meta.label}
        </span>
        <p className="history-meta-prompt">{item.prompt || '(프롬프트 없음)'}</p>
        <span className="history-meta-time">{formatTime(item.createdAt)}</span>
        {item.url && (
          <button className="history-dl-btn" onClick={download}>
            ↓ 다운로드
          </button>
        )}
      </div>
    </div>
  );
}

export default function HistoryPanel({ history, onClose }) {
  return (
    <div className="history-overlay">
      <div className="history-backdrop" onClick={onClose} />
      <div className="history-panel">
        <div className="history-header">
          <span className="history-title">HISTORY</span>
          <button className="history-close" onClick={onClose}>✕</button>
        </div>
        <div className="history-list">
          {history.length === 0 ? (
            <div className="history-empty">
              <span style={{ fontSize: '32px', opacity: 0.3 }}>📋</span>
              <span>아직 생성 기록이 없어요</span>
            </div>
          ) : (
            history.map(item => <HistoryItem key={item.id} item={item} />)
          )}
        </div>
      </div>
    </div>
  );
}
